import CircularProgress from '@mui/material/CircularProgress';

export const Spinner = ({ size = 40 , color = "primary" }) => {
   return (
    <div className="flex flex-row justify-center">
        <CircularProgress size={size} color={color} />
    </div>
   );
};
